import { TickIcon } from './Icons';

export { TickIcon };
